import { AiFillAppstore } from "react-icons/ai";
import {
  FaBrain,
  FaLaptopCode,
  FaProjectDiagram,
  FaTools,
} from "react-icons/fa";
import { SiProgress } from "react-icons/si";
import { CgWebsite } from "react-icons/cg";
import { MdAnalytics } from "react-icons/md";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <FaLaptopCode />,
    title: "Frontend Engineering",
    des: "8+ years of IT experience, including 6+ years in UI development, building scalable and maintainable web applications using React, JavaScript, TypeScript, and Next.js.",
  },
  {
    id: 2,
    icon: <CgWebsite />,
    title: "UI Architecture",
    des: "Experience working with reusable component libraries, microfrontend applications, and responsive UI patterns to deliver consistent user experiences.",
  },
  {
    id: 3,
    icon: <SiProgress />,
    title: "Performance & Quality",
    des: "Focused on application performance, code quality, maintainability, and automated testing to build reliable frontend solutions.",
  },
  {
    id: 4,
    icon: <FaProjectDiagram />,
    title: "Full-Stack Development",
    des: "Working knowledge of Node.js, Express, Python, and FastAPI for REST API development and frontend-backend integration.",
  },
  {
    id: 5,
    icon: <MdAnalytics />,
    title: "Generative AI Integration",
    des: "Familiar with LLM APIs, prompt engineering, and RAG fundamentals for integrating AI-powered capabilities into web applications.",
  },
  {
    id: 6,
    icon: <FaTools />,
    title: "Testing & CI/CD",
    des: "Experience with automated testing, code coverage, SonarQube, and CI/CD pipelines to support software quality and delivery.",
  },
];
